 const workerUrl = new URL('./test.worker.js', import.meta.url);

export const DetectOndemandOrReserve = (data, call) => {
  const worker = new Worker(workerUrl);
  worker.postMessage(JSON.stringify(data));
  worker.addEventListener("message", (event) => {
    call(event.data);
    worker.terminate();
  });
};
